<template>
  <div>
    <v-flex>
      <section>
        <v-card
          flat>
          <v-tabs
            v-model="selected.menu"
            background-color="transparent"
            color="#B71C1C"
            slider-size="5"
            show-arrows
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            dense
            grow
            class="d-flex justify-start tabs-stream">
            <v-tab
              v-for="(item, index) in list.menu"
              :key="index"
              class="px-0 mr-4 d-flex align-center">
              <v-avatar
                tile
                size="20">
                <v-img 
                  contain
                  :src="item.icon">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        size="20"
                        color="#B71C1C">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>

              <span 
                class="body-2 text-capitalize ml-2" 
                :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                {{ item.text }}
              </span>
            </v-tab>
          </v-tabs>

          <v-card-text 
            class="pa-0">
            <div v-if="selected.menu === 0">
              <Pppk />
            </div>

            <div v-if="selected.menu === 1">
              <Gadar />
            </div>

            <div v-if="selected.menu === 2">
              <Homecare />
            </div>
          </v-card-text>
        </v-card>
      </section>
    </v-flex>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },
        list: {
          menu: [
            {
              text: 'PPPK',
              value: 'pppk',
              icon: require('@/assets/image/service/pppk.png')
            },
            {
              text: 'Gawat Darurat',
              value: 'gadar',
              icon: require('@/assets/image/service/gadar_2.png')
            },
            {
              text: 'Home Care',
              value: 'homecare',
              icon: require('@/assets/image/service/home_care.png')
            }
          ]
        }
      }
    },
    components: {
      Pppk: () => import(/* webpackPrefetch: true */ '@/components/ppd/pppk.vue'),
      Gadar: () => import(/* webpackPrefetch: true */ '@/components/ppd/gadar.vue'),
      Homecare: () => import(/* webpackPrefetch: true */ '@/components/ppd/homecare.vue')
    },
    watch: {

    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    mounted () {
      this.selected.menu = this.$route.query.code === undefined ? 0 : parseInt(this.$route.query.code)
    },
    methods: {
      
    }
  }
</script>